import React from 'react';
import { Popover, Card, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { PlusCircleOutlined } from '@ant-design/icons';
import FormInput from '../../global/Forms/FormInput';

type VcdbPopoverProps = {
  disabled?: boolean;
  handleSave: (name: string) => Promise<any>;
};

const VcdbPopover: React.FC<VcdbPopoverProps> = props => {
  const { t } = useTranslation();

  const [popoverVisible, setPopoverVisible] = React.useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('validation:required')),
  });

  const formMethods = useForm({
    defaultValues: {
      name: '',
    },
    resolver: yupResolver(validationSchema),
    mode: 'onTouched',
  });

  const { handleSubmit, formState, reset } = formMethods;

  const onSubmit = async (values: { name: string }) => {
    await props.handleSave(values.name);
    setPopoverVisible(false);
  };

  React.useEffect(() => {
    if (!popoverVisible) {
      reset({ name: '' });
    }
  }, [popoverVisible, reset]);

  return (
    <Popover
      open={!props.disabled && popoverVisible}
      onOpenChange={visible => {
        setPopoverVisible(visible);
      }}
      overlayClassName="help application_listing__popover"
      placement="bottomLeft"
      destroyTooltipOnHide
      content={
        <Card className="qualifier__value-popover" bordered={false}>
          <FormProvider {...formMethods}>
            <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
              <FormInput name="name" label={t('application:vcdbName')} required useHookForm />
              <div className="flex-col items-end">
                <div>
                  <Button
                    onClick={() => setPopoverVisible(false)}
                    className="drawer-submit__bottom-cancel"
                  >
                    {t('common:cancel')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!formState.isDirty || formState.isSubmitting}
                    loading={formState.isSubmitting}
                  >
                    {t('common:save')}
                  </Button>
                </div>
              </div>
            </Form>
          </FormProvider>
        </Card>
      }
      trigger="click"
    >
      <Button className="ml-1" icon={<PlusCircleOutlined />} disabled={props.disabled} />
    </Popover>
  );
};

export default VcdbPopover;
